export default "__VITE_ASSET__Cpm9ZzaX__"